import { Entity, Column, PrimaryGeneratedColumn, ManyToOne, OneToMany, Unique, JoinColumn, OneToOne } from 'typeorm'

import Survey from './Survey'
import QuestionOption from './QuestionOption'

import { QuestionType } from '../entityTypes'
import { JSONObject } from '../../JsonType'
import Response from '../Response'
import QuestionConfiguration from '../testConfigurations/QuestionConfiguration'
import QuestionAsset from './QuestionAsset'

@Entity('questions')
@Unique('survey_question_index', ['qtestTapId', 'qtestDropId'])
export default class Question {
  @PrimaryGeneratedColumn('uuid')
  id!: string

  @Column({ name: 'created_at' })
  createdAt!: Date

  @Column({ name: 'qtest_drop_id' })
  qtestDropId!: number

  @Column({ name: 'qtest_tap_id' })
  qtestTapId!: string

  @Column({ name: 'is_screener' })
  isScreener!: boolean

  @Column()
  order!: number

  @Column({ type: 'enum', enum: QuestionType })
  type!: QuestionType

  @Column()
  text!: string

  @Column({ name: 'is_red_herring' })
  isRedHerring!: boolean

  @Column({ name: 'has_other_opt' })
  hasOtherOpt!: boolean

  @Column({ name: 'has_na_opt' })
  hasNaOpt!: boolean

  @Column({ name: 'has_explain_opt' })
  hasExplainOpt!: boolean

  // need more info relates to completes
  @Column({ name: 'has_terminating_option' })
  hasTerminatingOption!: boolean

  @Column({ type: 'text', array: true, name: 'qualifying_tags' })
  qualifyingTags!: string[]

  @Column({ type: 'text', array: true, name: 'parent_question_ids' })
  parentQuestionIds!: string[]

  @Column({
    type: 'jsonb',
    array: false,
    default: () => "'{}'",
    name: 'scale_properties'
  })
  scaleProperties!: JSONObject;

  @Column({
    type: 'jsonb',
    array: true,
    default: () => "'[]'",
    name: 'scale_groupings'
  })
  scaleGroupings!: JSONObject[];

  @Column()
  removed!: boolean

  @Column({ name: 'survey_id' })
  surveyId!: string

  @ManyToOne(type => Survey, survey => survey.questions)
  @JoinColumn({ name: 'survey_id' })
  survey!: Survey

  @OneToMany(type => QuestionOption, questionOption => questionOption.question)
  options?: QuestionOption[]

  @OneToMany(type => QuestionAsset, questionAsset => questionAsset.question)
  assets?: QuestionAsset[]

  @OneToMany(type => Response, response => response.question)
  responses!: Response[]

  @OneToOne(type => QuestionConfiguration, questionConfig => questionConfig.question)
  configuration!: QuestionConfiguration
}
